import { Models } from '$models';

type FreddieMacFields = Pick<Models.PropertyDetailsResponse, 'PROGRAMRECORDTYPE' | 'PROGRAM_NAME' | 'CYCLE'>;

export function isFreddieMacProperty(property?: FreddieMacFields | null): boolean {
  if (!property) {
    return false;
  }
  const { PROGRAMRECORDTYPE, PROGRAM_NAME, CYCLE } = property;
  return (
    PROGRAMRECORDTYPE === Models.ProgramRecordType.FIRST_LOOK ||
    PROGRAM_NAME === Models.ProgramRecordType.DAY_1 ||
    (PROGRAMRECORDTYPE === Models.ProgramRecordType.DAY_1 && CYCLE === Models.FIRST_LOOK_CYCLE)
  );
}
